import { Tooltip } from '@systemeio/ui'

export const ListOfItemsCell = <T,>({ items, entityName }: { items: T[]; entityName: string }) => {
  const visibleItems = items.slice(0, 2).map(item => item)
  const hiddenItems = items.slice(2, items.length)
  const hiddenItemsInPopup = hiddenItems.reduce((acc, item, index) => {
    if (index % 2 === 0) acc.push([])
    acc[acc.length - 1]?.push(item)
    return acc
  }, [] as T[][])

  return (
    <div className="w-full">
      {visibleItems.join(', ')}
      <Tooltip
        mode="click"
        label={
          <div className="flex flex-col flex-wrap items-start text-xs">
            {hiddenItemsInPopup.map((item, index) => (
              <span key={index}>{item.join(', ')}</span>
            ))}
          </div>
        }
      >
        {hiddenItems.length ? (
          <span className="text-brand-primary mx-1 cursor-pointer hover:underline">{`+${
            hiddenItems.length
          } ${entityName.toLowerCase()}`}</span>
        ) : (
          ''
        )}
      </Tooltip>
    </div>
  )
}
